import React from 'react'
import styled from 'styled-components'
import th from 'utils/themeHelper'
import { Error, Label, RequiredTag, SubLabel, Success } from '../InputLabels/InputLabels'

// character key codes for numbers, keypad numbers, tab, return, backspace, shift, arrows
const validKeyCodes = [
  8,
  9,
  13,
  16,
  37,
  38,
  39,
  40,
  48,
  49,
  50,
  51,
  52,
  53,
  54,
  55,
  56,
  57,
  96,
  97,
  98,
  99,
  100,
  101,
  102,
  103,
  104,
  105
]

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

const Input = styled.input`
  appearance: none;
  outline: none;
  border-radius: 3px;
  border-style: solid;
  border-color: ${({ requiredField, hasError, theme }) =>
    hasError
      ? theme.borders.error
      : requiredField
      ? theme.borders.required
      : theme.borders.default};
  border-width: ${({ requiredField, hasError }) =>
    hasError ? '2px' : requiredField ? '2px' : '1px'};
  color: ${th('text.dark')};
  background: ${({ disabled, theme }) => (disabled ? theme.backgrounds.mid : 'white')};
  font-size: 15px;
  width: 100%;
  height: 45px;
  padding: 10px 15px;

  @media screen and (min-width: 600px) {
    min-width: ${props => (props.fullWidth ? '100%' : props.shortNumberField ? '150px' : '500px')};
    max-width: ${props => (props.fullWidth ? '100%' : props.shortNumberField ? '150px' : '700px')};
  }

  &:hover {
    border-color: ${({ hasError, theme }) => (hasError ? theme.borders.error : theme.borders.dark)};
  }

  &:focus {
    border-color: ${({ hasError, theme }) =>
      hasError ? theme.borders.error : theme.secondary.base};
  }

  &::placeholder {
    color: ${th('text.light')};
    font-family: ${th('fonts.light')};
  }
`

const NumberInput = ({
  field,
  form: { errors, touched },
  fullWidth,
  requiredField,
  shortNumberField,
  min,
  max,
  label,
  subLabel,
  success,
  children,
  ...props
}) => {
  const displayableLabel = requiredField ? `${label} *` : label
  const hasError = !!errors[field.name]

  return (
    <Wrapper>
      {label && <Label htmlFor={field.name}>{displayableLabel}</Label>}
      {subLabel && <SubLabel subLabel={subLabel}>{subLabel}</SubLabel>}

      <RequiredTag hasError={hasError} label={label} requiredField={requiredField} />

      {children}

      <Input
        {...field}
        {...props}
        fullWidth={fullWidth}
        requiredField={requiredField}
        shortNumberField={shortNumberField}
        type="number"
        onKeyDown={e => {
          if (validKeyCodes.indexOf(e.keyCode) === -1) {
            e.preventDefault()
          }
        }}
        min={min || '0'}
        max={max || undefined}
        onWheel={event => event.currentTarget.blur()}
        step="1"
        touched={!!touched[field.name]}
        hasError={hasError}
      />

      {success && touched[field.name] && !errors[field.name] && <Success>{success}</Success>}
      {errors[field.name] && <Error>{errors[field.name]}</Error>}
    </Wrapper>
  )
}

export default NumberInput
